import { collection, doc, setDoc, updateDoc, getDoc, onSnapshot, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../lib/firebase';

export interface Presence {
  userId: string;
  online: boolean;
  lastActive: ReturnType<typeof serverTimestamp> | any;
  // Optional typing state scoped to a conversation
  typing?: boolean;
  typingConversationId?: string | null;
  typingAt?: ReturnType<typeof serverTimestamp> | any;
}

const PRESENCE_COLLECTION = 'presence';

export const setOnline = async () => {
  const user = auth.currentUser;
  if (!user) return;
  const ref = doc(db, PRESENCE_COLLECTION, user.uid);
  await setDoc(ref, { userId: user.uid, online: true, lastActive: serverTimestamp() }, { merge: true });
};

export const setOffline = async () => {
  const user = auth.currentUser;
  if (!user) return;
  const ref = doc(db, PRESENCE_COLLECTION, user.uid);
  await updateDoc(ref, { online: false, lastActive: serverTimestamp(), typing: false, typingConversationId: null });
};

export const updateLastActive = async () => {
  const user = auth.currentUser;
  if (!user) return;
  const ref = doc(db, PRESENCE_COLLECTION, user.uid);
  await updateDoc(ref, { lastActive: serverTimestamp() });
};

// Set typing state for the current user, optionally scoped to a conversation
export const setTyping = async (conversationId: string | null, isTyping: boolean) => {
  const user = auth.currentUser;
  if (!user) return;
  const ref = doc(db, PRESENCE_COLLECTION, user.uid);
  await setDoc(
    ref,
    {
      userId: user.uid,
      typing: isTyping,
      typingConversationId: isTyping ? conversationId || null : null,
      typingAt: serverTimestamp(),
      lastActive: serverTimestamp(),
    },
    { merge: true }
  );
};

export const subscribePresence = (
  userId: string,
  callback: (presence: Presence | null) => void
) => {
  const ref = doc(db, PRESENCE_COLLECTION, userId);
  return onSnapshot(ref, (snap) => {
    if (!snap.exists()) {
      callback(null);
    } else {
      callback(snap.data() as Presence);
    }
  });
};